export interface ValidatedCoupon {
  id: number;
  amount: number;
}

export const validatedCouponFromResponse = (
  responseData: any,
): ValidatedCoupon => ({
  id: responseData.id,
  amount: responseData.value.amount,
});
